<template>
  <div class="d-flex fill-height flex-column flex-fill p-relative card__wrapper">
    <v-container fluid class="pa-0 ma-0" v-if="!itemLote['blBaixa'] && !itemLote['blCarencia']">
      <v-row class="ma-0 pa-0 no-grace-and-casualty__row" />
    </v-container>
    <v-card
      flat
      height="100%"
      width="100%"
      class="card-com-lote-alocado"
      :class="[{
        'grace-period': itemLote['blCarencia'] && !itemLote['blBaixa'],
        'casualty': itemLote['blBaixa'] && !itemLote['blCarencia'],
        'grace-and-casualty': itemLote['blBaixa'] && itemLote['blCarencia']
      }]"
    >
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-row
            v-show="itemLote['blCarencia'] && !itemLote['blBaixa']"
            align="center"
            v-on="on"
            class="ma-0 grace-period__row px-4"
          >
            <v-icon left small color="white">fas fa-prescription-bottle-alt</v-icon>
            <span>Lote em carência</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote em período de carência</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Medicamento:</span>
            <span class="tooltip__text-bold pl-1">{{ (itemLote && itemLote["nmFarmaco"]) || "" }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Data Final:</span>
            <span
              class="tooltip__text-bold pl-1"
            >{{ itemLote ? $options.filters.datetimeFormat(itemLote["dtCarencia"]) : "" }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-row
            v-show="itemLote['blBaixa'] && !itemLote['blCarencia']"
            align="center"
            v-on="on"
            class="ma-0 casualty__row px-4"
          >
            <v-icon left small color="white">fas fa-book-dead</v-icon>
            <span>Lote com mortalidade</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote com baixa informada</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Nº de mortes:</span>
            <span class="tooltip__text-bold">{{ (itemLote && itemLote["qtBaixa"]) || "" }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{on}">
          <v-row
            v-show="itemLote['blBaixa'] && itemLote['blCarencia']"
            align="center"
            v-on="on"
            class="ma-0 grace-and-casualty__row px-4"
          >
            <v-icon left small color="white">fas fa-prescription-bottle-alt</v-icon>
            <v-icon left small color="white">fas fa-book-dead</v-icon>
            <span>Lote com carência e mortalidade</span>
          </v-row>
        </template>
        <v-container fluid class="pa-0">
          <v-row class="ma-0 py-1">
            <span class="tooltip__text-bold">Lote com baixa e carência informada</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Nº de mortes:</span>
            <span class="tooltip__text-bold">{{ (itemLote && itemLote["qtBaixa"]) || "" }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Medicamento:</span>
            <span class="tooltip__text-bold pl-1">{{ (itemLote && itemLote["nmFarmaco"]) || "" }}</span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="tooltip__text">Data Final:</span>
            <span
              class="tooltip__text-bold pl-1"
            >{{ itemLote ? $options.filters.datetimeFormat(itemLote["dtCarencia"]) : "" }}</span>
          </v-row>
        </v-container>
      </v-tooltip>
      <v-layout row justify-start ma-0 px-2 pt-2>
        <span class="label-produtor">Produtor</span>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              depressed
              icon
              x-small
              color="#BDCCCA"
              class="card-actions__btn info"
            >
              <v-icon x-small color="white">fas fa-info</v-icon>
            </v-btn>
          </template>
          <span>
            <span class="title-tooltip">Lote:</span>
            <span class="value-tooltip pl-1">
              {{
                itemLote.loteProducao.nrLoteControle
              }}
            </span>
            <br />
            <span class="title-tooltip">Extensionista:</span>
            <span class="value-tooltip pl-1">
              {{
                (itemLote.extensionista && itemLote.extensionista.nmPessoa) || ""
              }}
            </span>
            <br />
            <span class="title-tooltip">Cidade:</span>
            <span class="value-tooltip pl-1">
              {{
                itemLote.nmMunicipio
              }}
            </span>
          </span>
        </v-tooltip>
      </v-layout>
      <v-layout row justify-start pb-2>
        <v-flex lg11 pl-5>
          <span class="nome-produtor">{{ itemLote.loteProducao.jsonProdutor.nmProdutor }}</span>
        </v-flex>
      </v-layout>
      <v-row class="ma-0 px-4 infos-lote">
        <v-col cols="6" class="pa-0 py-2">
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Alocados</span>
            <span class="value-card-dados-lote pl-1">
              {{
                itemLote.qtAnimaisAlocados
              }}
            </span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Gênero</span>
            <span class="value-card-dados-lote pl-1">
              {{
                itemLote.dsTipoSexo
              }}
            </span>
          </v-row>
          <v-row class="ma-0 py-1">
            <span class="label-card-dados-lote">Tipo</span>
            <span class="value-card-dados-lote pl-1">
              {{
                itemLote.loteProducao.jsonUnidadeExploracao.csTipoUnidadeExploracao
              }}
            </span>
          </v-row>
        </v-col>
        <v-col cols="6" class="pa-0 py-1">
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Distância</span>
            <span class="value-card-dados-lote pl-1">
              {{
                itemLote.distanciaPlanta.nrValor
              }}
            </span>
            <span class="value-card-dados-lote pl-1">
              {{
                itemLote.distanciaPlanta.dsTipo
              }}
            </span>
          </v-row>
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Alojamento</span>
            <span class="value-card-dados-lote pl-1">{{ itemLote.nrDiasAlojado }} d</span>
          </v-row>
          <v-row justify="end" class="ma-0 py-1">
            <span class="label-card-dados-lote">Peso</span>
            <span class="value-card-dados-lote pl-1">{{ itemLote.nrPesoDia }} kg</span>
          </v-row>
        </v-col>
      </v-row>
      <v-layout row justify-center pl-5 pb-2 pr-5 mt-2>
        <v-flex lg12 v-if="itemCheckList.dtConfirmacaoProdutor != null">
          <DialogDadosChecKList :checkList="itemCheckList">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" color="#2bc1b6" class="btn-exibir-checklist">Visualizar Checklist</v-btn>
            </template>
          </DialogDadosChecKList>
        </v-flex>
        <v-flex lg12 v-else>
          <v-btn disabled large block class="btn-sem-checklist">Checklist não preenchido</v-btn>
        </v-flex>
      </v-layout>
      <v-layout row justify-center pl-5 pb-2 pr-5 mt-5>
        <v-flex lg12>
          <v-autocomplete
            dense
            :disabled="isFinished"
            v-model="sgPeriodoAbate"
            :items="listaPeriodos"
            placeholder="Período de abate"
            color="primary"
            item-text="dsPeriodo"
            item-value="dsPeriodo"
            label="Período de abate"
            outlined
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row justify-center pl-5 pb-2 pr-5 mt-5>
        <v-flex lg12>
          <menu-datepicker
            v-model="dtCarregamento"
            dense
            :disabled="isFinished"
            placeholder="Data de carregamento"
            color="primary"
            label="Data de carregamento"
            outlined
            clearable
            display-format="DD/MM/Y"
            :max-date="maxDateAllowed"
            :min-date="todaysDate"
            :should-use-allowed-dates="false"
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-layout row justify-center pl-5 pb-2 pr-5 mt-5>
        <v-flex lg12>
          <v-autocomplete
            dense
            :disabled="isFinished"
            v-model="sgPeriodoCarregamento"
            :items="listaPeridosCarreg"
            placeholder="Selecione o período de carregamento"
            color="primary"
            label="Selecione o período de carregamento"
            outlined
            clearable
            hide-details
          ></v-autocomplete>
        </v-flex>
      </v-layout>
      <v-layout row justify-center pl-5 pb-2 pr-5 mt-5>
        <v-flex lg12>
          <menu-timepicker 
            v-model="hrInicioJejum"
            dense
            :disabled="isFinished"
            placeholder="Hora de inicio do jejum"
            color="primary"
            label="Hora de inicio do jejum"
            outlined
            clearable
            hide-details
          />
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import {mapActions, mapState} from "vuex"
import {daysBetweenDates} from "@/filters/utils"

import DialogDadosChecKList from "@/modules/programacaoAbate/components/DialogDadosChecKList"
import moment, {ISO_8601} from "moment"
import SelectDate from "@/components/general/SelectDate"
import MenuDatepicker from "@/modules/common/components/MenuDatepicker"
import MenuTimepicker from "@/modules/common/components/MenuTimepicker"

export default {
  name: "CardItemLoteAlocadoCarregamento",
  components: {
    MenuDatepicker,
    SelectDate,
    DialogDadosChecKList,
    MenuTimepicker,
  },
  props: {
    itemData: {
      type: Object,
      default: {},
    },
    itemPlanta: {
      type: Object,
      default: {},
    },
    itemLote: {
      type: Object,
      default: {},
    },
  },
  filters: {
    datetimeFormat: (value, format = "DD/MM/Y") => {
      const parsedDate = moment(value, ISO_8601)
      if (!parsedDate.isValid()) return ""
      return parsedDate.format(format)
    },
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listCheckListAlocados",
      "programacaoAbateSelected",
    ]),
    todaysDate() {
      return moment(moment.now()).toISOString()
    },
    isFinished() {
      const dtFimAbate = moment(this.programacaoAbateSelected.dtFimAbate)
      return moment(moment.now()).isAfter(dtFimAbate)
    },
    maxDateAllowed() {
      const parsedDate = moment(this.itemData.text, "DD/MM/Y")
      if (!parsedDate.isValid()) return ""
      return parsedDate.toISOString()
    },
    sgPeriodoAbate: {
      get() {
        return this.itemCheckList
          ? this.itemCheckList.stAbatePeriodo
          : ""
      },
      set(val) {
        this.ActionChangePeriodoAbateValueItem({
          valueCheckList: this.itemCheckList,
          stAbatePeriodo: val,
        })
        this.$emit("periodoChanged")
      },
    },
    hrInicioJejum: {
      get() {
        return this.itemCheckList
          ? this.itemCheckList.hrInicioJejum
          : ""
      },
      set(val) {
        this.ActionChangePeriodoCarregamentoValueItem({
          valueCheckList: this.itemCheckList,
          sgPeriodoCarregamento: this.sgPeriodoCarregamento,
          dtCarregamento: this.itemCheckList.dtCarregamento,
          hrInicioJejum: val
        })
      },
    },
    dtCarregamento: {
      get() {
        return this.itemCheckList
          ? this.itemCheckList.dtCarregamento
          : ""
      },
      set(val) {
        let parsedDate = moment(val, "DD/MM/Y")
        if (!parsedDate.isValid()) parsedDate = null
        else parsedDate = parsedDate.format("Y-MM-DD")
        this.ActionChangePeriodoCarregamentoValueItem({
          valueCheckList: this.itemCheckList,
          sgPeriodoCarregamento: this.sgPeriodoCarregamento,
          dtCarregamento: parsedDate,
          hrInicioJejum: this.itemCheckList.hrInicioJejum
        })
      },
    },
    sgPeriodoCarregamento: {
      get() {
        return this.itemCheckList
          ? this.itemCheckList.stCarregamentoPeriodo
          : ""
      },
      set(val) {
        console.log(this.dtCarregamento)
        let parsedDate = moment(this.dtCarregamento, "Y-MM-DD")
        if (!parsedDate.isValid()) parsedDate = null
        else parsedDate = parsedDate.format("Y-MM-DD")
        
        this.ActionChangePeriodoCarregamentoValueItem({
          valueCheckList: this.itemCheckList,
          sgPeriodoCarregamento: val,
          dtCarregamento: parsedDate,
          hrInicioJejum: this.itemCheckList.hrInicioJejum
        })
      },
    },
    itemCheckList() {
      let item = this.listCheckListAlocados.find(
        (x) =>
          x.cdProgramacaoAbateAlocado == this.itemLote.idProgramacaoAbateAlocado
      )
      if (item != undefined) {
        return item
      }
      return {dtConfirmacaoProdutor: null}
    },
    listaPeridosCarreg() {
      return [
        {
          text: "Manhã",
          value: "manha"
        },
        {
          text: "Tarde",
          value: "tarde"
        },
        {
          text: "Noite",
          value: "noite"
        },
      ]
    },
    listaPeriodos() {
      if (this.$keycloak.tokenParsed["PARTNERID"] === 4) {
        return [
          {
            dsPeriodo: "1º Abate da manhã",
          },
          {
            dsPeriodo: "2º Abate da manhã",
          },
          {
            dsPeriodo: "Manhã toda",
          },
          {
            dsPeriodo: "1º Abate da tarde",
          },
          {
            dsPeriodo: "2º Abate da tarde",
          },
          {
            dsPeriodo: "Tarde toda",
          },
        ]
      } else {
        return [
          {
            dsPeriodo: "1º Abate da manhã",
          },
          {
            dsPeriodo: "2º Abate da manhã",
          },
          {
            dsPeriodo: "1º Abate da tarde",
          },
          {
            dsPeriodo: "2º Abate da tarde",
          },
        ]
      }
    }
  },
  methods: {
    ...mapActions("programacaoAbate", [
      "ActionLoadDistanciaPlantaAbateEstabelecimento",
      "ActionChangePeriodoCarregamentoValueItem",
      "ActionChangePeriodoAbateValueItem"
    ]),
    daysBetweenDates,
    showInfosChecklist(itemLote) {
      return
    },
  },
}
</script>

<style>
.btn-exibir-checklist {
  width: 100%;
  background-color: rgb(43, 193, 182);
  border-color: rgb(43, 193, 182);
  color: white !important;
  border-radius: 4px;
  opacity: 1;
}
</style>
